import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, PRIMARY_OUTLET, NavigationEnd } from '@angular/router';
import {UserService} from '../../services/user.service';

import {environment} from '../../../environments/environment';
import { UpaegService } from 'src/app/services/upaeg.service';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public upaegVinculada: any;
  public isVentanilla: boolean;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private upaegService : UpaegService
  ) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }

  ngOnInit() {
    this.isVentanilla = false;
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
    /* VALIDATE SESSION */

    this.upaegVinculada = false;
    this.watchMyUpaegs();
    this.isVentanilla = this.userService.getIdentity().ventanilla;
  }


  watchMyUpaegs() {
    this.upaegService.getMyUpaegs().subscribe(result => {
      console.log(result);
      console.log('De wathc upaegs');
      if (result.status) {
        this.upaegVinculada = result.fisicas[0].id_productor;
      }
    }, error => {
      console.log(error);
      this.upaegVinculada = false
    });
  }

}
